import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

// https://fireship.io/lessons/sharing-data-between-angular-components-four-methods/

@Injectable({
  providedIn: 'root',
})
export class MenutitleService {
  private messageSource = new BehaviorSubject('Timing.Mobi');
  currentMessage = this.messageSource.asObservable();

  private headerColor = new BehaviorSubject(true);
  currentHeaderColor = this.headerColor.asObservable();

  constructor() {}

  changeMenutitle(message: string) {
    this.messageSource.next(message);
  }

  showMenupink(pinkheader: boolean) {
    this.headerColor.next(pinkheader);
  }
}
